import classes from "./MentorCreateCase.module.css"
import "@fontsource/roboto"
import InputBlock from "components/UI/inputBlock/InputBlock"
import { useState, useRef, useEffect } from 'react'
import Description from "components/UI/description/Description"
import Button from "components/UI/buttons/button/Button"
import Tooltip from "rc-tooltip"
import 'rc-tooltip/assets/bootstrap_white.css';
import { useDeviceType } from "components/hooks/useDeviceType"
import { useDispatch } from "react-redux"
import TaskService from "services/TaskService"
import { useFetching } from "components/hooks/useFetching"
import { changeLoaderStatus } from "redux/slice/loaderSlice"
import NotificationManager from "react-notifications/lib/NotificationManager"
import Notifications from "../popupNotifications/Notifications"
import Strings from "values/Strings"
import Loader from "../loader/Loader"
import DragAndDrop from "../dragAndDrop/DragAndDrop"
import DragAndDropPlaceholder from "../dragAndDrop/DragAndDropPlaceholder"
import { AiOutlineClose } from "react-icons/ai"
import CategoryParticipantService from "services/CategoryParticipantService"
import { newName } from "redux/slice/titleSlice"
import { useNavigate } from "react-router-dom"
import { privateRoutNames } from "router"


const MentorUpdateCase = ({ setOriginalUpdateCase, taskId, originalUpdateCase, uuid }) => {

    const notificationError = (error) => {
        if (error.length > 0) {
            NotificationManager.error(JSON.stringify(error), Strings.notificationsErrorTitle, 5000);
        }
    }

    const notificationWarning = (error) => {
        if (error.length > 0) {
            NotificationManager.warning(error, Strings.notificationsWarningTitle, 5000);
        }
    }

    const [updateCase, setUpdateCase] = useState({ ...originalUpdateCase });

    const [dragEndDropText, setDragEndDropText] = useState("")
    const dragZoneRef = useRef()
    // -------------------------------------DragAndDrop------------------------------------
    function imagePreview(imageFile) {
        setUpdateCase(old => ({ ...old, presentation: imageFile }))
        NotificationManager.success(Strings.notificationsAddFile, Strings.notificationsSuccessTitle, 2500);
    }

    function removeImage() {
        setUpdateCase(old => ({ ...old, presentation: null }))
        // NotificationManager.success(Strings.notificationsRemoveFile, Strings.notificationsSuccessTitle, 2500);
    }
    // ------------------------------------------------------------------------------

    const ref = useRef()
    const device = useDeviceType()
    const dispatch = useDispatch()

    const verificationCompleteness = (data) => {
        if (data.occasion === undefined || data.occasion === null || data.occasion === '') {
            notificationWarning('Мероприятие не выбрано!')
            return false
        }
        if (data.title === undefined || data.title === null || data.title === '') {
            notificationWarning('Поле "Название" не заполнено!')
            return false
        }
        if (data.category === undefined || data.category === null || data.category === '') {
            notificationWarning('Поле "Категория" не заполнено!')
            return false
        }
        if (data.prize === undefined || data.prize === null || data.prize === '') {
            notificationWarning('Поле "Приз" не заполнено!')
            return false
        }
        if (data.presentation === undefined || data.presentation === null || data.presentation === '') {
            notificationWarning('Поле "Презентация" не заполнено!')
            return false
        }
        if (data.contact_tg === undefined || data.contact_tg === null || data.contact_tg === '') {
            notificationWarning('Поле "Контакты" не заполнено!')
            return false
        }
        if (data.specification === undefined || data.specification === null || data.specification === '') {
            notificationWarning('Поле "Описание" не заполнено!')
            return false
        }
        if (data.expected_result === undefined || data.expected_result === null || data.expected_result === '') {
            notificationWarning('Поле "Ожидаемый результат" не заполнено!')
            return false
        }
        return true
    }


    const [dataAboutCategory, setDataAboutCategory] = useState([])
    const [getCategoryParticipant, loadingCategoryParticipant, errorCategoryParticipant] = useFetching(async (id) => {
        try {
            const res = await CategoryParticipantService.getOneByTaskId(id)
            setDataAboutCategory(res)
            dispatch(changeLoaderStatus(false))
        } catch (error) {
            notificationError(error)
        }
    }, false)

    const navigate = useNavigate()
    const [updateTask, loadingTask, errorTask] = useFetching(async (updateCase) => {
      try {
            if (originalUpdateCase.status !== 3) {
                if (JSON.stringify(originalUpdateCase) !== JSON.stringify(updateCase)) {
                    const result = verificationCompleteness(updateCase)
                    const id = updateCase.id
                    const updateCaseCopy = { ...updateCase }
                    delete updateCaseCopy.id
                  if (result) {
                    let res = null
                      if(uuid) {
                        res = await TaskService.updateTaskByUuid({ data: updateCaseCopy, uuid })
                      } else {
                        res = await TaskService.updateTask({ data: updateCaseCopy, id })
                      }
                        if (res) {
                            setOriginalUpdateCase(res)
                            setUpdateCase(res)
                            await NotificationManager.success(Strings.notificationsCaseCUpdated, Strings.notificationsSuccessTitle, 2500);
                            if(localStorage.getItem('accessToken')){
                                navigate(`/private/${privateRoutNames.mentorCase}`)
                            }
                        }
                    }
              } else {
                  if(localStorage.getItem('accessToken')){
                      navigate(`/private/${privateRoutNames.mentorCase}`)
                  } else {
                      notificationError(Strings.notificationsErrorCaseNotUpdated)
                  }
              }
            }
        } catch (error) {
            notificationError(error)
        }
    })

    useEffect(() => {
        dispatch(newName(Strings.updateCase))
        getCategoryParticipant(taskId)
    }, [])

    useEffect(() => {
        setUpdateCase({ ...originalUpdateCase })
    }, [originalUpdateCase])


    return (
        <Loader localStatus={loadingTask || loadingCategoryParticipant}>
            <div ref={ref} className={classes.events__create__style}>
                <ul>
                    {Object.keys(updateCase).length > 0 && <>
                        {(originalUpdateCase?.comment && originalUpdateCase.status === 4) && (device === "phone"
                            ? <li>
                                <Description placeholder={"Замечание к кейсу"} charactesLeftStatus={false} value={originalUpdateCase.comment} readOnly={true} />
                            </li>
                            : <li>
                                <Description placeholder={"Замечание к кейсу"} charactesLeftStatus={false} value={originalUpdateCase.comment} onListStatus={false} readOnly={true} />
                            </li>)
                        }
                        {device === "phone"
                            ? <li>
                                <InputBlock setValue={char => setUpdateCase(old => ({ ...old, title: char }))} value={updateCase?.title} onListStatus={false} placeholder={"Название кейса"}><img src={require("assets/icon/pencil.jpg")} /></InputBlock>
                            </li>
                            : <li>
                                <InputBlock placeholder={"Название кейса"} setValue={char => setUpdateCase(old => ({ ...old, title: char }))} value={updateCase?.title} onListStatus={false}><img src={require("assets/icon/pencil.jpg")} /></InputBlock>
                            </li>
                        }
                        {dataAboutCategory.length > 0 && (device === "phone"
                            ? <li>
                                <div className={classes.input__block}>
                                    {dataAboutCategory.map((item, key) => <div key={key} className={classes.form_radio_btn}>
                                        <input id={`caseB-${key}`} type="radio" name="caseB" checked={item.id === updateCase.category} value={item.id} onChange={char => setUpdateCase(old => ({ ...old, category: parseInt(char.target.value) }))} />
                                        <label htmlFor={`caseB-${key}`}>{item.name}</label>
                                    </div>)}
                                </div>
                            </li>
                            : <li>
                                <div className={classes.text__style}>
                                    <span className={classes.style__title}>*Категория:</span>
                                </div>
                                <div className={classes.input__block}>

                                    {dataAboutCategory.map((item, key) => <Tooltip key={key} placement="top" trigger={'hover'} overlay={<span style={{ fontSize: "0.7vw", fontFamily: "Roboto" }} className={classes.tooltip__style}>{item.description}</span>}>
                                        <div className={classes.form_radio_btn}>
                                            <input id={`caseB-${key}`} type="radio" name="caseB" checked={item.id === updateCase.category} value={item.id} onChange={(char) => {
                                                return setUpdateCase(old => ({ ...old, category: parseInt(char.target.value) }))
                                            }} />
                                            <label htmlFor={`caseB-${key}`}>{item.name}</label>
                                        </div></Tooltip>
                                    )}
                                </div>
                            </li>
                        )}

                        {(dataAboutCategory && device === "phone")
                            ? <li>
                                <InputBlock setValue={char => setUpdateCase(old => ({ ...old, prize: char }))} value={updateCase?.prize} onListStatus={false} placeholder={"Приз"}><img src={require("assets/icon/pencil.jpg")} /></InputBlock>
                            </li>
                            : <li>
                                <InputBlock placeholder={"Приз"} setValue={char => setUpdateCase(old => ({ ...old, prize: char }))} value={updateCase?.prize} onListStatus={false}><img src={require("assets/icon/pencil.jpg")} /></InputBlock>
                            </li>
                        }

                        {device === "phone"
                            ? <li className={classes.li__style}>
                                {updateCase.presentation
                                    ? <div className={classes.down__block__style} onClick={removeImage}>
                                        <div className={classes.drop__down__style}>
                                            <span>Удалить файл</span>
                                            <AiOutlineClose color="rgb(210, 12, 12)" />
                                        </div>
                                    </div>
                                    : <DragAndDrop justifyContent="left" imagePreview={imagePreview} borderStyle={'none'} dragZoneRef={dragZoneRef}
                                        setDragZoneText={setDragEndDropText} textDragZone="Добавить презентацию">
                                        <DragAndDropPlaceholder height={'11vw'} imagePreview={imagePreview} dragZoneRef={dragZoneRef}>{dragEndDropText}</DragAndDropPlaceholder>
                                    </DragAndDrop>
                                }
                            </li>
                            : <li className={classes.li__style}>
                                {updateCase.presentation
                                    ? <div className={classes.presentation__container}>
                                        <span>Презентация загружена</span> <AiOutlineClose onClick={removeImage} color="rgb(210, 12, 12)" />
                                    </div>
                                    : <DragAndDrop justifyContent="left" imagePreview={imagePreview} borderStyle={'none'} dragZoneRef={dragZoneRef}
                                        setDragZoneText={setDragEndDropText} textDragZone="Вставить презентацию">
                                        <DragAndDropPlaceholder height={'15vw'} width={'60vw'} right={'0vw'} imagePreview={imagePreview} dragZoneRef={dragZoneRef}>{dragEndDropText}</DragAndDropPlaceholder>
                                    </DragAndDrop>
                                }
                            </li>
                        }

                        {device === "phone"
                            ? <li>
                                <InputBlock setValue={char => setUpdateCase(old => ({ ...old, additional_material: char }))} value={updateCase?.additional_material} onListStatus={false} placeholder={"Доп. материал (ссылка)"}><img src={require("assets/icon/pencil.jpg")} /></InputBlock>
                            </li>
                            : <li>
                                <InputBlock placeholder={"Ссылка на доп. материал"} setValue={char => setUpdateCase(old => ({ ...old, additional_material: char }))} value={updateCase?.additional_material} onListStatus={false}><img src={require("assets/icon/pencil.jpg")} /></InputBlock>
                            </li>
                        }
                        {device === "phone"
                            ? <li>
                                <InputBlock setValue={char => setUpdateCase(old => ({ ...old, contact_tg: char }))} value={updateCase?.contact_tg} onListStatus={false} placeholder={"Ссылка на соц. сети"}><img src={require("assets/icon/pencil.jpg")} /></InputBlock>
                            </li>
                            : <li>
                                <InputBlock placeholder={"Ссылка на соц. сети для связи"} setValue={char => setUpdateCase(old => ({ ...old, contact_tg: char }))} value={updateCase?.contact_tg} onListStatus={false}><img src={require("assets/icon/pencil.jpg")} /></InputBlock>
                            </li>
                        }

                        {device === "phone"
                            ? <li className={classes.li__style}>
                                <Description setValue={char => setUpdateCase(old => ({ ...old, specification: char }))} value={updateCase?.specification} placeholder={"Описание"} />
                            </li>
                            : <li className={classes.li__style}>
                                <Description placeholder={"Описание кейса"} setValue={char => setUpdateCase(old => ({ ...old, specification: char }))} value={updateCase?.specification} />
                            </li>
                        }

                        {device === "phone"
                            ? <li className={classes.li__style}>
                                <Description setValue={char => setUpdateCase(old => ({ ...old, expected_result: char }))} value={updateCase?.expected_result} placeholder={"Ожидаемый результат"} />
                            </li>
                            : <li className={classes.li__style}>
                                <Description placeholder={"Ожидаемый результат"} setValue={char => setUpdateCase(old => ({ ...old, expected_result: char }))} value={updateCase?.expected_result} />
                            </li>
                        }
                    </>}
                </ul>
                {Object.keys(updateCase).length > 0 &&
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "end" }}>
                        <Button onClick={() => updateTask(updateCase)}>Отправить</Button>
                    </div>
                }
                <Notifications />
            </div >
        </Loader>
    )
}

export default MentorUpdateCase